import { createReducer } from "reduxsauce";

import UIDs from "../../UIDs";

import ReducerRegister from "../ReducerRegister";
import { ActionTypes } from "../actionTypes/layouts/MobileActionTypes";
import MobileLayoutService from "../../services/layouts/MobileLayoutService";
import AsyncActionReducers from "../AsyncActionReducers";

//
// Actions
//
const Actions = {
    loadScreenViewAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, });

            MobileLayoutService.loadApp(
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        data,
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error,
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    // companyList: []
};

//
// Reducers
//
// const loadSuccessPostReducer = (state, { data }) => {
//     return { ...state, companyList: data };
// };

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(UIDs.layouts.practice, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
